<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import AddPlatform from "@/own/components/datahub/platforms/AddPlatform";
import EditPlatform from "@/own/components/datahub/platforms/EditPlatform";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/platforms.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
export default {
  name: "Platforms",
  components: { DataTable },
  data: () => ({
    componentForEditing: EditPlatform,
    componentForAdding: AddPlatform,
    delete_url: `${process.env.VUE_APP_BASE_URL}/datahub/platforms/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getPLATFORMSTableFilters",
      getTableState: "getPLATFORMSTableState",
      getTableData: "getPLATFORMSTableData",
      getTableHeaders: "getPLATFORMSTableHeaders",
      getTableProperties: "getPLATFORMSTableProperties",
      getTableExportUrl: "getPLATFORMSExportUrl",
      getTablePermissions: "getPLATFORMSTablePermissions",
    },
    urls: {
      delete: `${process.env.VUE_APP_BASE_URL}/datahub/platforms/destroy`,
      activate: `${process.env.VUE_APP_BASE_URL}/authorizations/users/activate`,
      status: `${process.env.VUE_APP_BASE_URL}/authorizations/users/status`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
